
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 95 65"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"fill":"#413E3E","d":"M84.7 62.7H41.8V35.3h-5.3c-1 0-1.9-.6-2.3-1.6-.4-1-.1-2 .7-2.7l27-22.5c.9-.8 2.2-.8 3.1 0L91.9 31c.8.7 1.1 1.7.7 2.7-.4 1-1.2 1.6-2.3 1.6h-5.6v27.4zM45 59.5h36.5V32.1h6.8L63.5 11.4 38.6 32.1H45v27.4z"}}),_c('path',{attrs:{"d":"M57.2 41.9v19.2h12.5V41.9H57.2zm10.9 17.6h-9.3v-16h9.3v16z","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#fff"}}),_c('path',{staticClass:"st0",attrs:{"fill":"#413E3E","d":"M55.6 40.3v22.4h15.7V40.3H55.6zm12.5 19.2h-9.3v-16h9.3v16z"}}),_c('path',{attrs:{"d":"M7 63.4c-.2 0-.4 0-.6-.1-.8-.3-1.2-1.2-1-2 .2-.8.5-1.9.8-3.3.4-1.5 1.4-4.1 3-7.7 1.7-3.6 3.7-6.9 6-9.7 2.3-2.9 5.7-5.5 10.1-7.8 3.9-2.1 8.3-3.3 13-3.5V19.1c0-.7.4-1.3 1-1.6.2-.1.5-.1.7-.1.4 0 .8.1 1.1.4l23.5 21.3c.4.3.6.8.6 1.3s-.2 1-.6 1.3L41 61.6c-.3.2-.7.4-1.1.4-.2 0-.5-.1-.7-.2-.6-.3-1-.9-1-1.5V48.4c-7.6.1-13.6 1-17.9 2.7-4.5 1.7-8.4 5.6-11.9 11.5-.2.5-.8.8-1.4.8z","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#00becc"}}),_c('path',{attrs:{"d":"M39.9 15.7c-.5 0-.9.1-1.4.3-1.2.5-2 1.8-2 3.1v8.6c-4.3.4-8.4 1.6-12.1 3.6-4.5 2.4-8.1 5.2-10.6 8.2-2.4 2.9-4.5 6.3-6.2 10-1.8 3.8-2.8 6.3-3.2 8-.3 1.4-.6 2.5-.8 3.3-.4 1.6.5 3.3 2 4 .4.2.8.2 1.3.2 1.2 0 2.3-.6 2.9-1.7 3.2-5.6 6.9-9.2 11-10.8 3.8-1.5 9.1-2.3 15.6-2.5v10.2c0 1.3.8 2.5 2 3.1.5.2.9.3 1.4.3.8 0 1.6-.3 2.2-.8L65.6 43c.8-.6 1.2-1.6 1.2-2.5 0-1-.4-1.9-1.1-2.6L42.2 16.6c-.6-.6-1.4-.9-2.3-.9zm0 3.4l23.5 21.3-23.5 19.9V46.6c-8.6 0-15.4.9-20.2 2.8-4.9 1.9-9.1 6-12.7 12.3.2-.8.5-1.9.8-3.3.3-1.4 1.3-3.9 2.9-7.4s3.5-6.6 5.7-9.3 5.4-5.2 9.6-7.4S34.8 31 39.9 31V19.1z","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#413e3e"}})])
          )
        }
      }
    